module.exports = __webpack_public_path__ + "media/customizations/rksouthhoa/logo-7f5b4f770cc3b6216c027362392bfd0a.png";